import { Box } from '@wanteddev/wds-engine';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';

// src/icon-circle-check-fill.tsx
var IconCircleCheckFill = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(
    Box,
    {
      as: "svg",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      ref,
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.09991 12.0001C2.09991 6.53248 6.5323 2.1001 11.9999 2.1001C17.4675 2.1001 21.8999 6.53248 21.8999 12.0001C21.8999 17.4677 17.4675 21.9001 11.9999 21.9001C6.5323 21.9001 2.09991 17.4677 2.09991 12.0001ZM16.6466 9.87594C16.9923 9.51878 16.983 8.94901 16.6259 8.60331C16.2687 8.25762 15.6989 8.26691 15.3533 8.62406L10.6773 13.455L8.64748 11.3522C8.30227 10.9946 7.73251 10.9845 7.37488 11.3297C7.01726 11.6749 7.00719 12.2447 7.3524 12.6023L10.0289 15.3751C10.1983 15.5506 10.4318 15.6498 10.6758 15.65C10.9198 15.6502 11.1534 15.5513 11.3231 15.3759L16.6466 9.87594Z",
          fill: "currentColor"
        }
      )
    }
  );
});
var icon_circle_check_fill_default = IconCircleCheckFill;

export { icon_circle_check_fill_default as default };
